/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/AssignmentTurnedIn.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const AssignmentTurnedIn: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="none" viewBox="0 0 16 18" ref={ref} {...props}>
    <path
      fill={color}
      d="M6.32 14.18 3 10.82l1.172-1.172 2.148 2.149 5.508-5.469L13 7.5zM8 2.5q.351 0 .586.234a.8.8 0 0 1 .234.586.93.93 0 0 1-.234.625A.8.8 0 0 1 8 4.18a.8.8 0 0 1-.586-.235.93.93 0 0 1-.234-.625q0-.352.234-.586A.8.8 0 0 1 8 2.5m5.82 0h-3.476a2.52 2.52 0 0 0-.938-1.21A2.3 2.3 0 0 0 8 .82q-.781 0-1.445.47a2.6 2.6 0 0 0-.899 1.21H2.18q-.704 0-1.211.508Q.499 3.476.5 4.18v11.64q0 .704.469 1.211.508.47 1.21.469H13.82q.704 0 1.172-.469.508-.508.508-1.21V4.18q0-.705-.508-1.172A1.53 1.53 0 0 0 13.82 2.5"
    />
  </svg>
);
AssignmentTurnedIn.displayName = "AssignmentTurnedIn";
